// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SummarySubscriptionItem-module-subscriptionProduct-M8Q2T{background:#fbfbfb;padding:10px;border-radius:8px;margin-bottom:10px}.SummarySubscriptionItem-module-singleItemList-SNzBJ{height:23px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subscriptionProduct": "SummarySubscriptionItem-module-subscriptionProduct-M8Q2T",
	"singleItemList": "SummarySubscriptionItem-module-singleItemList-SNzBJ"
};
export default ___CSS_LOADER_EXPORT___;
